import React, { ReactNode } from "react";
import {
  Box,
  Container,
  CssBaseline,
  Typography,
  Paper,
  Link,
} from "@mui/material";
import PiHealthLogo from "./Logo";
import { useLocation } from "react-router-dom";

interface FormLayoutProps {
  title: string;
  children: ReactNode;
}

function Copyright(props: any) {
  return (
    <>
      <Typography variant="body1" {...props}>
        {"Copyright © "} {new Date().getFullYear()}{" "}
      </Typography>
    </>
  );
}

const FormLayout: React.FC<FormLayoutProps> = ({ title, children }) => {
  const location = useLocation();
  return (
    <Box className="landingPageBg minH100">
      <Container component="main" maxWidth="lg">
        <CssBaseline />
        <Box className="dFlex minH100 alignItemsCenter">
          <Box className="leftLogoSection">
            <Typography component="h1" variant="h1" className="formTitle">
              Sample Management System
            </Typography>
            <Box className="copyrightBottom">
              <Copyright />
              <Link
                target="_blank"
                rel="noreferrer"
                href="https://www.pihealth.ai"
                aria-label="Visit PiHealth website, which opens in a new window."
              >
                <PiHealthLogo />
              </Link>
            </Box>
          </Box>
          <Paper elevation={8}>
            <Box className="formBox">
              <Typography
                component="h1"
                variant="h3"
                className="formTitle"
                sx={{ mt: 2 }}
              >
                {title}
              </Typography>
              {children}
              {location?.pathname !== `/forgotPassword` && (
                <Typography
                  align="center"
                  variant="body2"
                  sx={{ mt: 8, mb: -2, mx: -1 }}
                >
                  {`By signing in, you agree to our website's `}
                  <Link
                    target="_blank"
                    rel="noopener"
                    href="https://www.pihealth.ai/termsofuse.html"
                    aria-label="To learn more, visit the Terms & Conditions page of PiHealth which opens in a new window."
                  >
                    Terms & Conditions
                  </Link>{" "}
                  and{" "}
                  <Link
                    target="_blank"
                    rel="noopener"
                    href="https://www.pihealth.ai/privacy.html"
                    aria-label="To learn more, visit the Privacy page of PiHealth which opens in a new window."
                  >
                    Privacy Statement
                  </Link>
                </Typography>
              )}
            </Box>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
};

export default FormLayout;
